<template>
  <div class="account-content__subtitle display-flex-sb"
    v-if="!isMobile">
      <div class="">{{$t('DELETE_ACCOUNT')}}</div>
      <!-- save profile -->
      <div class="">
        <div
          v-show="enableDeleteButton"
          class="enable-button mt-0 btn-aspn-primary"
          @click="openConfirmDeleteModal"
        >
          {{ $t("PERMANENTLY_DELETE_MY_ACCOUNT") }}
        </div>
        <div v-show="!enableDeleteButton" class="disable-button mt-0 btn-aspn-primary disabled">
          {{ $t("PERMANENTLY_DELETE_MY_ACCOUNT") }}
        </div>
          <!-- <button class="btn disable " :class="{'enable':isSaveBtnEnable}" @click="handleSavePassword">{{$t('SAVE')}}</button> -->
      </div>
  </div>

  <div class="account-content__wrapper">
    <div v-show="step === 0">
      <div class="title fz16">{{ $t("DELETE_ACCOUNT_INTRO_TITLE") }}</div>
      <ol class="instruction">
        <li>{{ $t("DELETE_ACCOUNT_STEP_1") }}</li>
        <li>{{ $t("DELETE_ACCOUNT_STEP_2") }}</li>
        <li>{{ $t("DELETE_ACCOUNT_STEP_3") }}</li>
        <li>{{ $t("DELETE_ACCOUNT_STEP_4") }}</li>
        <li>{{ $t("DELETE_ACCOUNT_STEP_5") }}</li>
        <li>{{ $t("DELETE_ACCOUNT_STEP_6") }}</li>
      </ol>
      <div class="enable-button" @click="nextStep(1)">
        {{ $t("PROCEED") }}
      </div>
    </div>
    <div v-show="step === 1">
      <div class="title fz16">{{ $t("DELETE_ACCOUNT_IMPACT_TITLE") }}</div>
      <ul class="instruction">
        <!-- <li>{{ $t("DELETE_ACCOUNT_IMPACT_1") }}</li>
        <li>{{ $t("DELETE_ACCOUNT_IMPACT_2") }}</li>
        <li>{{ $t("DELETE_ACCOUNT_IMPACT_3") }}</li> -->
      </ul>
      <p class="instruction remark mb-15rem">{{ $t("DELETE_ACCOUNT_IMPACT_REMARK") }}</p>
      <div class="subtitle">{{ $t("WHY_DELETE_ACCOUNT") }}</div>
      <div
        id="SelectAReason"
        class="selected-reason-wrapper"
        @click="toggleReasonList"
      >
        <span>{{ selectedReasonText }}</span>
        <span class="dropdown-select-arrow" :class="{
          'rotate': showReasonList
        }">
          <SvgIcon icon="c.header.newsCaret"></SvgIcon>
          <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"
            class="dropdown-select-arrow"
            :class="{ rotate: showReasonList }">
            <path d="M12.6654 6L7.9987 10L3.33203 6" stroke="#121416" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg> -->
          <!-- <svg
            class="dropdown-select-arrow"
            :class="{ rotate: showReasonList }"
            width="12"
            height="10"
            viewBox="0 0 12 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.516782 1.33746C0.952782 0.802265 1.55978 0.760265 2.09278 1.33746L6.00078 5.83386L9.90878 1.33746C10.4418 0.760265 11.0498 0.802265 11.4828 1.33746C11.9188 1.87146 11.8908 2.77386 11.4828 3.27546C11.0768 3.77706 6.78778 8.67786 6.78778 8.67786C6.57078 8.94546 6.28578 9.07986 6.00078 9.07986C5.71578 9.07986 5.43078 8.94546 5.21178 8.67786C5.21178 8.67786 0.924782 3.77706 0.516782 3.27546C0.108782 2.77386 0.0807824 1.87146 0.516782 1.33746Z"
              fill="white"
            />
          </svg> -->
        </span>
      </div>
      <div
        class="selection-reason-container"
        v-show="showReasonList && !isMobile"
      >
        <!-- <perfect-scrollbar class="perfect-scrollball__medium"> -->
        <div class="selection-reason-inner-container">
          <div
            class="selection-reason"
            :class="{ selected: selectedReasonId === o.key }"
            @click="userSelectAReason(o)"
            v-for="o in reasonList"
            :key="o.key"
          >
            <span>{{ $t(o.key) }}</span>
            
            <SvgIcon icon="c.team.tick" v-if="selectedReasonId === o.key"></SvgIcon>
            
          </div>
        </div>
        <!-- </perfect-scrollbar> -->
      </div>
      <div
        v-show="selectedReasonId === 'DELETE_ACCOUNT_REASON_9'"
        class="other-reason-container"
      >
        <div class="subtitle">{{ $t("WRITE_OPTIONAL_REASON") }}</div>
        <div class="form-group__container form-group__textarea-container">
          <perfect-scrollbar class="perfect-scrollball__medium">
            <textarea
              class="form-control textarea"
              rows="4"
              :placeholder="$t('WRITE_YOUR_REASON_HERE')"
              v-model="otherDeleteReason"
            ></textarea>
          </perfect-scrollbar>
        </div>
      </div>
  
      <div v-if="isMobile">
        <div
          v-show="enableDeleteButton"
          class="enable-button btn-aspn-primary"
          @click="openConfirmDeleteModal"
        >
          {{ $t("PERMANENTLY_DELETE_MY_ACCOUNT") }}
        </div>
        <div v-show="!enableDeleteButton" class="disable-button btn-aspn-primary disabled">
          {{ $t("PERMANENTLY_DELETE_MY_ACCOUNT") }}
        </div>
      </div>
    </div>
  </div>


  <ModalPopup ref="modalPopupSubmitRef" class="modal-container-remove-account">
    <div class="display-flex-align-center flex-col modal-confirmation__body">
      <div class="mb-15rem font-m popup-title">
        {{ $t("WE_SAD_TO_SEE_YOU_GO") }}
      </div>
      <div class="mb-15rem font-m">
        {{ $t("SURE_TO_DELETE_ACCOUNT") }}
      </div>
      <div class="w-100">
        <button class="btn btn-aspn-default selected w-100 mb-1rem  btn-confirm" @click="deleteUserAccount">
          {{ $t("CONFIRM") }}
        </button>
        <button class="btn btn-outline w-100 btn-cancel btn-aspn-default" @click="closeConfirmDeleteModal">
          {{ $t("CANCEL") }}
        </button>
      </div>
    </div>
  </ModalPopup>

  <ModalPopup
    ref="modalPopupDeletedRef"
    :isShowCloseButton="false"
    @handleCloseEvent="closeDeletedModal"
  >
    <div class="display-flex-align-center flex-col modal-confirmation__body">
      <div class="mb-15rem font-m">
        <div class="fav-login-tips__title">{{ $t("ACCOUNT_DELETED_1") }}</div>
        <div class="fav-login-tips__text" v-html="$t('ACCOUNT_DELETED_2')"></div>
      </div>
      <div class="w-100">
        <button class="btn btn-aspn-primary w-100 mb-1rem" @click="closeDeletedModal">
          {{ $t("BACK_TO_SCORE") }}
        </button>
      </div>
    </div>
  </ModalPopup>
</template>

<script>
import ModalPopup from "@/components/modal/ModalPopup.vue";
import { mapGetters, mapActions } from "vuex";
import MobileSelect from "@/lib/mobile-select/mobile-select";

const OTHER_REASON = "DELETE_ACCOUNT_REASON_9";

export default {
  components: {
    ModalPopup,
  },
  watch: {
    otherDeleteReason: {
      handler(newVal, oldVal) {
        // this.enableDeleteButton = newVal ? true : false;
        if (newVal.length >= 100)
          this.otherDeleteReason = newVal.substring(0, 100);
      },
    },
  },
  computed: {
    ...mapGetters([
      "isMobile",
      "currentLocale",
      "isLogin",
      "userInfo",
      "currentLanguageObj",
    ]),
    selectedReasonText() {
      if (this.selectedReasonId === null) return this.$t("SELECT_A_REASON");
      else return this.$t(this.selectedReasonId);
    },
  },
  mounted() {
    if (this.isMobile) this.mobileSelector();
    // this.hintYScrollbar();

    // this.openDeletedModal()
  },
  data() {
    return {
      step: 1,
      selectedReasonId: null,
      showReasonList: false,
      selectedReason: null,
      enableDeleteButton: false,
      otherDeleteReason: null,
      reasonList: [
        {
          key: "DELETE_ACCOUNT_REASON_1",
          value: "No longer using AsiaSports",
        },
        {
          key: "DELETE_ACCOUNT_REASON_2",
          value: "Too many permissions / Privacy concern",
        },
        {
          key: "DELETE_ACCOUNT_REASON_3",
          value: "High Storage Space",
        },
        {
          key: "DELETE_ACCOUNT_REASON_4",
          value: "A lot of crashes, errors or keeps freezing",
        },
        {
          key: "DELETE_ACCOUNT_REASON_5",
          value: "High data consumption",
        },
        {
          key: "DELETE_ACCOUNT_REASON_6",
          value: "Draining battery",
        },
        {
          key: "DELETE_ACCOUNT_REASON_7",
          value: "AsiaSports is not updating frequently",
        },
        {
          key: "DELETE_ACCOUNT_REASON_8",
          value: "Poor user interface",
        },
        {
          key: "DELETE_ACCOUNT_REASON_9",
          value: "Other reasons",
        },
      ],
    };
  },
  methods: {
    ...mapActions(["postDeleteUserAccount"]),
    // hintYScrollbar() {
    //   this.$nextTick(() => {
    //     let yScrollbarSlot = document.querySelector(".ps__rail-y");
    //     let yScrollbar = document.querySelector(".ps__thumb-y");
    //     yScrollbarSlot.style.height = "100%";
    //     yScrollbarSlot.style.display = "block";
    //     yScrollbar.style.height = "100%";
    //     yScrollbar.style.display = "block";
    //   })
    // },
    mobileSelector() {
      if (this.isMobile) {
        let that = this;

        let triggerId = "#SelectAReason";
        let title = this.$i18n.t("SELECT_A_REASON");
        let ensureBtnText = this.$i18n.t("DONE");
        let cancelBtnText = this.$i18n.t("CANCEL");

        let ensureBtnColor = "var(--color-text-primary-default)";
        let titleBgColor = "#F0F0F0";
        let translatedReasonList = [];

        for (let i = 0; i < this.reasonList.length; i++) {
          translatedReasonList.push({
            key: this.reasonList[i].key,
            value: this.$t(this.reasonList[i].key),
          });
        }

        this.msInstance = new MobileSelect({
          trigger: triggerId,
          title: title,
          ensureBtnText: ensureBtnText,
          cancelBtnText: cancelBtnText,
          ensureBtnColor: ensureBtnColor,
          titleBgColor: titleBgColor,
          triggerDisplayData: false,
          wheels: [{ data: translatedReasonList }],

          callback: function (indexArr, data) {
            // this.periodSelected = data[0];
            that.userSelectAReason(data[0]);
          },
        });
      }
    },
    openConfirmDeleteModal() {
      this.$refs.modalPopupSubmitRef.handleOpen();
    },
    closeConfirmDeleteModal() {
      this.$refs.modalPopupSubmitRef.handleClose();
    },
    openDeletedModal() {
      this.$refs.modalPopupDeletedRef.handleOpen();
    },
    closeDeletedModal() {
      // this.$refs.modalPopupDeletedRef.handleClose();
      this.$router.replace({ name: "home" });
    },
    async deleteUserAccount() {
      let result;
      let params = {
        remark: this.selectedReason,
        token: this.userInfo.token,
      };
      if (
        this.selectedReasonId === OTHER_REASON &&
        this.otherDeleteReason !== null
      )
        params.remark = this.$t(OTHER_REASON) + " - " + this.otherDeleteReason;
      result = await this.postDeleteUserAccount(params);
      if (result.message === "Success") {
        this.closeConfirmDeleteModal();
        this.openDeletedModal();
      }
    },
    nextStep(next) {
      this.step = next;
    },
    toggleReasonList() {
      this.showReasonList = !this.showReasonList;
      // this.hintYScrollbar();
    },
    userSelectAReason(o) {
      this.selectedReasonId = o.key;
      this.selectedReason = this.$t(o.key); //o.value
      this.toggleReasonList();
      if (this.selectedReasonId !== null) this.enableDeleteButton = true;
      else this.enableDeleteButton = false;
    },
  },
};
</script>

<style scoped>
.title {
  font-size: 22px;
  /* font-family: var(--weight-700); */
  line-height: 26px;
  text-align: left;
}
.instruction {
  font-size: 16px;
  font-family: var(--weight-400);
  line-height: 20px;
  text-align: left;
	letter-spacing: 0.64px;
}
.remark {
  background-color: var(--color-background-warning-secondary);
  color: var(--color-text-error-default);
  border: 1px solid var(--color-border-warning-default);
  border-radius: 8px;
  padding: 12px 16px;
  font-weight: 700 !important;

}
ol {
  padding-left: 20px;
}
ul {
  padding: 16px 0 16px 30px;
}
ul li::marker {
  content: initial;
}
.subtitle {
  /* line-height: 13px; */
  font-size: 16px;
	letter-spacing: 0.64px;
}
.enable-button {
  background: var(--color-background-success-default);
  color: var(--color-button-active);
  text-align: center;
  font-size: 14px;
  font-family: var(--weight-700);
  line-height: 20px;
  padding: 10px 12px;
  border-radius: 4px;
  margin-top: 24px;
  cursor: pointer;
	letter-spacing: 0.64px;
}
.disable-button {
  background: var(--color-background-default-tertiary);
  color: var(--color-text-default-tertiary);
  border: 1px solid var(--color-border-default-default);
  text-align: center;
  font-size: 14px;
  font-family: var(--weight-700);
  line-height: 20px;
  padding: 10px 12px;
  border-radius: 4px;
  margin-top: 24px;
  cursor: not-allowed;
	letter-spacing: 0.64px;
}
.selected-reason-wrapper {
  display: flex;
  justify-content: space-between;
  background: var(--color-background-default-secondary);
  color:var(--color-text-default-default);
  border: 1px solid var(--color-border-default-default);
  font-size: 14px;
  font-family: var(--weight-400);
  line-height: 21px;
  padding: 12px 16px;
  border-radius: 4px;
  margin: 3px 0 0px 0;
  position: relative;
  cursor: pointer;
	letter-spacing: 0.64px;
}
.selection-reason-container {
  border-radius: 8px;
  background: var(--color-background-default-secondary);
  color: var(--color-text-default-default);
  border: 1px solid var(--color-border-default-default);
  font-size: 14px;
  font-family: var(--weight-400);
  line-height: 21px;
  position: absolute;
  z-index: 1;
  max-width: 368px;
  width: 100%;
  box-sizing: border-box;
  padding: 5px 5px 5px 0;
	letter-spacing: 0.64px;
  margin-top: 3px;
}
.selection-reason-inner-container {
  max-height: 170px;
  overflow-y: scroll;
}
.selection-reason-inner-container::-webkit-scrollbar-track {
  border-radius: 10px;
  right: 8px;
}
.selection-reason-inner-container::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: var(--color-background-default-default);
}
.selection-reason-inner-container::-webkit-scrollbar-thumb:hover {
  background: var(--color-background-default-default-hover);
}
.selection-reason-inner-container::-webkit-scrollbar {
  width: 9px;
  height: 9px;
}
.other-reason-container {
  margin-top: 24px;
}
.selection-reason {
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 10px;
}
.selection-reason:hover {
  background-color: var(--color-background-default-tertiary-hover);
}
.selection-reason.selected {
  background-color: var(--color-background-default-tertiary-hover);
}
.dropdown-select-arrow {
  transition: all 0.2s;
}
.dropdown-select-arrow.rotate {
  transform: rotate(180deg);
}
/* .perfect-scrollball__medium {
  max-height: 10.625rem;
} */
.form-group__textarea-container {
  margin-top: 3px;
}
.textarea {
  min-height: 7.5rem;
  max-height: 7.5rem;
  max-width: 52.1rem;
  width: 52.1rem;
  resize: none;
}
.popup-title {
  font-size: 20px;
  font-family: var(--weight-600);
  color: var(--color-text-default-default);
}
@media(max-width: 768px) { /* for test */
  .title {
    font-size: 16px;
    font-weight: normal;
    line-height: 22px;
    text-align: left;
    letter-spacing: 0.64px;
  }
  .instruction {
    font-size: 14px;
    font-family: var(--weight-400);
    line-height: 21px;
    text-align: left;
    letter-spacing: 0.64px;
  }
  .instruction li {
    list-style: disc;
  }
  .remark {
    
    font-size: 13px;
  }
  ol {
    padding-left: 20px;
  }
  ul {
    padding: 16px 0 16px 30px;
  }
  ul li::marker {
    content: initial;
  }
  .subtitle {
    padding-bottom: 8px;
  }
}
.btn-confirm {
  padding: 12px;
  border-radius: 8px;
  font-family: var(--weight-700);
  font-size: 16px;
	letter-spacing: 0.64px;
}
.account-content__subtitle {
    font-size: 20px;
    color: var(--color-text-default-default);
    font-family: var(--weight-700);
    margin-bottom: 32px;
}
.mt-0 {
  margin-top: 0;
}
.fz16 {
  font-size: 16px;
	letter-spacing: 0.64px;
}
.account-content__wrapper {
    max-width: 368px;
}
.fav-login-tips__title {
    color: var(--color-text-default-default);
    font-size: var(--typography-heading-size-extra-small);
    padding-bottom: 24px;
    font-family: var(--weight-600);
}
.fav-login-tips__text{
    margin-bottom: 24px;
    font-size: 16px;
    color: var(--color-text-default-default);
	letter-spacing: 0.64px;
}
@media(max-width: 768px) {
.account-content__wrapper {
    padding-bottom: 16px;
}  
}
</style>

<style>
.modal-container-remove-account .modal-container {
  padding: 24px;
  width: 400px;
}
.modal-container-remove-account .modal-confirmation__body {
  margin: 0;
  align-items: baseline;
  color: var(--color-text-default-default);
}
.modal-container-remove-account .modal-header {
  display: none;
}

@media(max-width: 768px) {
.modal-container-remove-account .modal-container {
  /* padding: 24px; */
  width: 90%;
}
}
</style>